import { useEffect } from 'react';
import { useQuery } from '../../../../query-context';
import { ProductStates } from '../../../../product-state-machine/product-state-machine-types';

/**
 * Updates the analytics contexts which depend on the current product state.
 */
export var useAnalyticsUpdate = function useAnalyticsUpdate(productState) {
  var _useQuery = useQuery(),
    setAdditionalAnalyticsContext = _useQuery.setAdditionalAnalyticsContext;
  useEffect(function () {
    var isLoading = productState === ProductStates.PreQueryLoading || productState === ProductStates.PostQueryLoading;
    setAdditionalAnalyticsContext({
      type: 'isLoading',
      value: isLoading
    });
  }, [productState, setAdditionalAnalyticsContext]);
};